<template>
  <div class="wrapper">

    <side-bar type="sidebar" :sidebar-links="filteredLinks">
      <user-menu></user-menu>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'

  export default {
    data(){
      return {
        filteredLinks : []
      }
    },
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    },
    beforeMount(){
      const userType = sessionStorage.getItem("account-type")
      if(userType != "SOPORTE"){
        var tempLinks = []
        this.$sidebar.sidebarLinks.forEach(link => {
          if (!link.requireSupport){
            tempLinks.push(link)
          }
        });
        this.filteredLinks = [...tempLinks]
      } else {
        this.filteredLinks = [...this.$sidebar.sidebarLinks]
      }
    }
  }

</script>
